var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgWeight = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M21.874 83.617c-.81-.203-1.18-1.772-1.265-2.53 3.458-.422 10.375-1.013 10.375 0 0 1.011-1.18 2.108-1.771 2.53-2.11.084-6.53.202-7.339 0ZM66.419 83.617c-.81-.203-1.181-1.772-1.266-2.53 3.459-.422 10.375-1.013 10.375 0 0 1.011-1.18 2.108-1.77 2.53-2.11.084-6.53.202-7.34 0Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M19.602 60.841h56.937c.927 4.555 2.834 14.272 3.036 16.702.203 2.429-1.434 3.374-2.277 3.542H21.626c-4.858 0-5.398-2.361-5.06-3.542l3.036-16.702Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M24.153 41.092h48.333c.93 2.505 7.135 13.594 7.338 14.93.203 1.336-2.215 4.715-3.06 4.808H21.715c-4.87 0-5.999-3.905-5.66-4.555l8.097-15.183Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.813 57.185h40.176M62.279 57.185h3.443M68.013 57.185h1.721M72.044 57.185h1.722"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48.033 80.92H30.867s-.572 2.857-1.43 2.857h-7.153c-.859 0-1.43-2.856-1.43-2.856h-1.431c-2.003 0-3.148-.857-2.861-2.857 0 0 2.431-14.283 2.86-17.14-2.431-2.428-4.291-3.428-2.86-5.713l6.437-12.712h47.898"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M48.03 80.92h17.166s.572 2.857 1.43 2.857h7.153c.858 0 1.43-2.856 1.43-2.856h1.43c2.004 0 3.148-.857 2.862-2.857 0 0-2.432-14.283-2.861-17.14 2.432-2.428 4.291-3.428 2.86-5.713l-6.293-12.712M19.688 80.934h56.136M19.422 60.935h57.22"
  }), React.createElement("rect", {
    width: 3.092,
    height: 1.944,
    x: 55.576,
    y: 67.122,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 0.972
  }), React.createElement("rect", {
    width: 3.092,
    height: 1.944,
    x: 55.576,
    y: 72.872,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 0.972
  }), React.createElement("rect", {
    width: 3.092,
    height: 1.944,
    x: 61.31,
    y: 67.122,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 0.972
  }), React.createElement("rect", {
    width: 3.092,
    height: 1.944,
    x: 61.31,
    y: 72.872,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 0.972
  }), React.createElement("rect", {
    width: 3.092,
    height: 1.944,
    x: 67.044,
    y: 67.122,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 0.972
  }), React.createElement("rect", {
    width: 3.092,
    height: 1.944,
    x: 67.044,
    y: 72.872,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 0.972
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M44.504 66.653H29.546a4 4 0 0 0-4 4v.61a4 4 0 0 0 4 4h14.958a4 4 0 0 0 4-4v-.61a4 4 0 0 0-4-4Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeWidth: 0.75,
    d: "M29.608 70.883v1.792c0 .139.112.25.25.25h2.223a.25.25 0 0 0 .25-.25v-1.792m-2.723 0v-1.792a.25.25 0 0 1 .25-.25h2.223a.25.25 0 0 1 .25.25v1.792m-2.723 0h2.723M33.687 70.883v1.792c0 .139.111.25.25.25h2.223a.25.25 0 0 0 .25-.25v-1.792m-2.723 0v-1.792a.25.25 0 0 1 .25-.25h2.223a.25.25 0 0 1 .25.25v1.792m-2.723 0h2.723M37.78 70.883v1.792c0 .139.112.25.25.25h2.223a.25.25 0 0 0 .25-.25v-1.792m-2.723 0v-1.792a.25.25 0 0 1 .25-.25h2.223a.25.25 0 0 1 .25.25v1.792m-2.723 0h2.723",
    opacity: 0.35
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M44.456 69.82v2.294c0 .396-.11.695-.33.899-.217.203-.54.304-.966.304-.22 0-.433-.029-.636-.087a1.75 1.75 0 0 1-.532-.238l.181-.455c.313.19.637.284.971.284.448 0 .672-.22.672-.66v-.331a.804.804 0 0 1-.33.33c-.146.076-.31.114-.497.114-.22 0-.416-.052-.589-.155a1.107 1.107 0 0 1-.398-.444 1.427 1.427 0 0 1-.144-.656c0-.248.046-.467.14-.656.096-.193.23-.341.402-.445.172-.106.369-.16.59-.16.185 0 .35.04.495.12a.773.773 0 0 1 .33.325v-.383h.641Zm-1.296 1.953c.206 0 .366-.067.48-.202.117-.134.176-.318.176-.552 0-.238-.059-.424-.176-.558-.114-.135-.274-.202-.48-.202a.604.604 0 0 0-.48.202c-.118.134-.176.32-.176.558 0 .23.058.415.175.552a.604.604 0 0 0 .48.202Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    d: "M32.331 68.84h-2.473a.25.25 0 0 0-.25.25v1.543c0 .138.112.25.25.25h2.223a.25.25 0 0 1 .25.25v1.542a.25.25 0 0 1-.25.25h-2.473"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "square",
    strokeWidth: 0.75,
    d: "M33.687 72.675V69.09a.25.25 0 0 1 .25-.25h2.223a.25.25 0 0 1 .25.25v3.585a.25.25 0 0 1-.25.25h-2.223a.25.25 0 0 1-.25-.25ZM37.78 72.675V69.09a.25.25 0 0 1 .25-.25h2.223a.25.25 0 0 1 .25.25v3.585a.25.25 0 0 1-.25.25H38.03a.25.25 0 0 1-.25-.25Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m23.654 20.391 3.643-4.164a7.25 7.25 0 0 1 5.456-2.477h30.838a7.25 7.25 0 0 1 5.66 2.721l3.61 4.511a3.25 3.25 0 0 1 .712 2.03v2.264l-50.71.58-.013-3.312a3.25 3.25 0 0 1 .804-2.153Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m42.63 20.285 2.054-6.535h6.467l2.061 6.535H42.63Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22.844 24.155a3.25 3.25 0 0 1 3.25-3.25h44.229a3.25 3.25 0 0 1 3.25 3.25v25.576a3.25 3.25 0 0 1-3.25 3.25h-44.23a3.25 3.25 0 0 1-3.25-3.25V24.155Z"
  }), React.createElement("path", {
    fill: neutral ? 'var(--color-neutral-90)' : 'var(--color-secondary-100)',
    fillRule: "evenodd",
    d: "M62.244 48.69c-.544 0-.918-.46-.918-1.14 0-.686.374-1.146.918-1.146s.919.46.919 1.14c0 .686-.375 1.146-.919 1.146Zm-.003.879c1.006 0 1.805-.855 1.805-2.008 0-1.14-.756-2-1.805-2-1.006 0-1.806.854-1.806 2.007 0 1.159.756 2 1.806 2Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: neutral ? 'var(--color-neutral-90)' : 'var(--color-feedback-success-90)',
    fillRule: "evenodd",
    d: "M64.794 48.04h1.725c.118 0 .187-.071.187-.194v-.563c0-.123-.069-.195-.187-.195h-1.156v-2.396c0-.123-.069-.194-.188-.194h-.568c-.119 0-.188.071-.188.194v2.96c0 .252.132.388.375.388Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: neutral ? 'var(--color-neutral-90)' : 'var(--color-primary-100)',
    fillRule: "evenodd",
    d: "m67.132 49.499 1.038-1.237 1.006 1.237c.087.11.2.11.3.02l.406-.37c.1-.09.112-.207.018-.31l-1.118-1.296 1.019-1.185c.087-.103.08-.213-.02-.31l-.38-.357c-.1-.097-.213-.09-.3.02l-.931 1.12-.95-1.12c-.088-.104-.2-.117-.3-.02l-.394.363c-.1.097-.106.2-.012.31l1.037 1.186-1.13 1.301c-.095.11-.082.22.018.311l.394.356c.1.091.212.084.3-.02Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26.141 46.435h4.217M26.141 49.685h8.3"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M53.313 22.124a.75.75 0 0 0-.75-.75h-9.142a.75.75 0 0 0-.75.75v7.142a2.75 2.75 0 0 0 2.75 2.75h5.142a2.75 2.75 0 0 0 2.75-2.75v-7.142Z"
  }));
};
export default SvgWeight;